<script setup>
import {ref} from 'vue';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Textarea from 'primevue/textarea';
import { storeToRefs } from 'pinia';
import { useCadernoStore } from './useCardernoStore';
const store = useCadernoStore();
const { anotacoes } = storeToRefs(store);

const modosComentario = ref(["Texto", "Dados Estruturados"])
const modoComentarioSelecionado = ref("Texto");
const textoInserido = ref("");

const comentarioStruturado = ([
    {
        "idAnotacao": 418,
        "comentario": "Esse é um comentário sobre a anotação 418"
    },
    {
        "idAnotacao": 260,
        "comentario": "Esse é um comentário sobre a anotação 260"
    }
]
);

function comentar(){
    if(modoComentarioSelecionado.value == "Texto"){
        inserirComentariosTexto();
    }else if(modoComentarioSelecionado.value == "Dados Estruturados"){
        inserirComentariosEstruturados();
    }
}

function inserirComentariosTexto(){
   anotacoes.value.forEach(estudante => {
       estudante.anotacoes.forEach(a => {
           if(a.condicao == 'exibir'){
               a.comentario = textoInserido.value
           }
       })
   }) 

}

function inserirComentariosEstruturados(){
    try {

        const comentariosArray = JSON.parse(textoInserido.value);

        anotacoes.value.forEach(estudante => {
            estudante.anotacoes.forEach(nota => {
                let comentario = comentariosArray.find(comentario => comentario.idAnotacao == nota.id);

                if (comentario != undefined && comentario.idAnotacao === nota.id) {
                    nota.comentario = comentario.comentario;
                }
            })
        }) 


    } catch (error) {
        console.error("Erro ao tentar parsear a string JSON:", error);
    }
}

</script>
<template>
    <div class="flex flex-column gap-5">
        <h3 class="mb-0 flex justify-content-between">
            <div>Comentários em massa
                <i v-tooltip.top="'Inserir comentários em todas as anotações visíveis'"
                    class="pi pi-info-circle ml-2"></i>
            </div>
            <a class="no-underline text-base text-primary font-normal" target="_blank"
                href="https://chatgpt.com/g/g-N9Z2zgHHN-criador-de-feedback-de-textos">Gerador de
                Feedback</a>
        </h3>

        <div class="flex flex-column gap-2">
            <label>Formato do comentário</label>
            <Dropdown v-model="modoComentarioSelecionado" :options="modosComentario" class="w-full md:w-56" />
        </div>

        <Textarea v-model="textoInserido" rows="10" class="w-full" />

        <div class="flex flex-column gap-2">
            <Button label="Inserir comentários" @click="comentar" />
        </div>
    </div>
</template>